import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/15_turquoise_skies/15_turquoise_skies"
 * Contains 1 texture(s)
 */
export class Desktop15TurquoiseSkiesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/15_turquoise_skies/15_turquoise_skies';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '15_turquoise_skies.jpg'
    ] as const;
}
